/**
 * Supabase client (frontend) — uses the anon key, protected by RLS.
 *
 * NEVER swap this for the service_role key in the frontend. The service_role
 * key bypasses RLS and would expose every user's data to every browser. The
 * service_role key lives only on Chris's EC2 box in moneyschool-api/.env.
 */

import { createClient, type Session, type User } from "@supabase/supabase-js";

const URL = import.meta.env.VITE_SUPABASE_URL;
const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!URL || !ANON_KEY) {
  // Don't crash the whole app — auth-dependent features will just be unavailable.
  // eslint-disable-next-line no-console
  console.warn("[supabase] env vars missing — auth + Plaid features disabled");
}

export const supabase = (URL && ANON_KEY)
  ? createClient(URL, ANON_KEY, {
      auth: {
        persistSession: true,           // remember user across page reloads
        autoRefreshToken: true,
        detectSessionInUrl: true,       // for magic links — harmless if we use OTP
        flowType: "pkce",
      },
    })
  : null;

export type { Session, User };

export const isSupabaseReady = !!supabase;
